export const environment = {
  production: false,
  bypass_login: false, // automatically logs in using a test user account, does not work in production
  host_api_default: '',
  chart_upload_timeout_ms: 5000,
  host_api_default_mock: '.' // mock api endpoint for calls
};
